export default "__VITE_ASSET__DPBTiDZJ__"